import { render } from "./FormAddressView.vue?vue&type=template&id=e71a2fc4"
import script from "./FormAddressView.vue?vue&type=script&lang=js"
export * from "./FormAddressView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__